<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">
						Manage Credit Requests
					</div>
					<div class="card-body overflow-auto">
						<table class="table table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th>Company/Branch</th>
									<th>Lead Name</th>
									<th>Lead Phone</th>
									<th>Status</th>
									<th>Requested Credit</th>
									<th>Allocated Credit</th>
									<th>Notes</th>
									<th>Manage</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="i in requests">
									<td>{{i.company_id}}/{{i.branch_code}}</td>
									<td>{{i.lead_name}}</td>
									<td>{{i.phone}}</td>
									<td>{{i.status}}</td>
									<td>{{i.requested_credit}}</td>
									<td>{{i.allocated_credit}}</td>
									<td>{{i.status}}</td>
									<td>
										<button class="btn btn-success" @click="statusPrompt(i.id, 'approved')">Approve</button>
										<button class="btn btn-danger" @click="statusPrompt(i.id, 'decline')">Decline</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer">
						<pagination :pagination="pagination"
						 	@prev="getRequests(pagination.prevPageUrl)"
						  @next="getRequests(pagination.nextPageUrl)"
						></pagination>
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->

<div class="modal" tabindex="-1" role="dialog" id="statusmodal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Manage Request</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group" v-if="prompt == 'approved'">
        	<label>Allocate Amount</label>
        	<input type="number" class="form-control" placeholder="Enter the amount to allocate" v-model="allocated">
        	<span class="badge badge-danger" v-if="errors.allocated">Please enter a valid value</span>
        </div>
        <div class="form-group">
        	<label>Notes</label>
        	<input type="text" class="form-control" placeholder="Enter the notes" v-model="notes">
        	<span class="badge badge-danger" v-if="errors.notes">Please enter a valid value</span>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary"  v-if="prompt == 'approved'" @click="approveRequest">Approve</button>
        <button type="button" class="btn btn-primary"  v-else-if="prompt == 'declined'" @click="denyRequest">Decline</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination:Pagination},

        created(){
        	this.getRequests();
        },

        data(){
        	return {
        		requests: [],
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		curr: '',
         		prompt: '',
         		notes: '',
         		allocated: '',
         		errors: []
        	}
        },

        methods:{
        	getRequests(url="/api/getCreditRequests"){
        		axios.post(url)
        		.then(response => {
        			this.requests = response.data.data.data;
        			this.configPagination(response.data.data);
        		});
        	},

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

        	statusPrompt(id, status){
        		this.prompt = status;
        		this.curr = id;
        		$("#statusmodal").modal("show");
        	},

        	approveRequest(){
        		axios.post("/api/approveCreditRequest", {id: this.curr, allocated: this.allocated, notes: this.notes})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Credit Allocated'
        			});
        			this.curr = '';
        			this.allocated = '';
        			this.notes = '';
        			$("#statusmodal").modal("hide");
        		})
        		.catch((errors) => {
        			toast.fire({
        				icon: 'error',
        				title: 'Failed'
        			});
        			this.errors = errors.response.data.errors;
        		});
        	},

        	denyRequest(){
        		axios.post("/api/declineCreditRequest", {id: this.curr, notes: this.notes})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Credit Allocated'
        			});
        			this.curr = '';
        			this.notes = '';
        			$("#statusmodal").modal("hide");
        		})
        		.catch((errors) => {
        			toast.fire({
        				icon: 'error',
        				title: 'Failed'
        			});
        			this.errors = errors.response.data.errors;
        		});
        	}
        }
    }
</script>
